import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import { useUser } from '../contexts/UserContext';
import styles from './AdminLayout.module.css'; 

const AdminLayout = () => {
  const { user, loading } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  if (loading) return <p>Loading...</p>; // or a spinner
  if (!user) return <p>Not authenticated</p>; // or redirect
  return (
    <div className="d-flex flex-column flex-md-row">
        <AdminSidebar userRole={user.role} isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content area */}
      <main className={`${styles.mainContent} ${!isSidebarOpen ? styles.expanded : ''} p-4 p-md-5`}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
